import React, { FC, SyntheticEvent } from 'react';
import triggerTracking from '@blueprint/tracking';

import { Tab } from '../HeroContainer/HeroContainer.types';
import homepageTranslations from 'public/locales/en/homepage.json';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { BuyRentTabsWrapper, BuyRentTab } from './BuyRentTabs.styles';
import { TaxonomySection } from 'shared/tracking/contracts';

const t = getTranslator(homepageTranslations);

export type Props = {
    onPress: (tab: Tab) => void;
    selected: Tab;
    includeHousePrices: boolean;
    testIdSuffix: 'desktop-homepage' | 'mobile' | 'mobile-modal';
};

const buyTabText = t('search_tabs.buy');
const rentTabText = t('search_tabs.rent');
const housePricesTabText = t('search_tabs.house_prices');

export const BuyRentTabs: FC<Props> = ({
    onPress,
    selected,
    testIdSuffix,
    includeHousePrices
}) => {
    const handlePress = (eventLabel: Tab) => {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: TaxonomySection.HOMEPAGE,
            eventAction: 'channel_tab',
            eventLabel
        });

        onPress(eventLabel);
    };

    return (
        <BuyRentTabsWrapper
            includeHousePrices={includeHousePrices}
            role="tablist"
        >
            <BuyRentTab
                href="/for-sale/"
                onClick={(event: SyntheticEvent) => {
                    event.preventDefault();
                    handlePress('for-sale');
                }}
                isSelected={selected === 'for-sale'}
                width="78px"
                data-testid={`for-sale-tab-${testIdSuffix}`}
            >
                {buyTabText}
            </BuyRentTab>
            <BuyRentTab
                href="/to-rent/"
                onClick={(event: SyntheticEvent) => {
                    event.preventDefault();
                    handlePress('to-rent');
                }}
                isSelected={selected === 'to-rent'}
                width="78px"
                data-testid={`to-rent-tab-${testIdSuffix}`}
            >
                {rentTabText}
            </BuyRentTab>
            {includeHousePrices ? (
                <BuyRentTab
                    href="/house-prices/"
                    role="tab"
                    onClick={(event: SyntheticEvent) => {
                        event.preventDefault();
                        handlePress('house-prices');
                    }}
                    isSelected={selected === 'house-prices'}
                    width="107px"
                    data-testid={`house-prices-tab-${testIdSuffix}`}
                >
                    {housePricesTabText}
                </BuyRentTab>
            ) : null}
        </BuyRentTabsWrapper>
    );
};
